import React, { useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom';
import * as AuthAPI from '../services/authAPI';
import Field from '../components/Field';

export default function SetPasswordPage({ mode }) {

    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token') || '';

    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    const isInvitation = mode === 'invitation';
    const title = isInvitation ? 'Créer mon mot de passe' : 'Nouveau mot de passe';
    const buttonLabel = isInvitation ? 'Activer mon compte' : 'Réinitialiser';
    const successMessage = isInvitation
        ? 'Votre compte est activé. Vous pouvez maintenant vous connecter.'
        : 'Votre mot de passe a été réinitialisé. Vous pouvez maintenant vous connecter.';

    const handleSubmit = async event => {
        event.preventDefault();
        if (submitting) return;
        setSubmitting(true);
        setError('');
        try {
            if (isInvitation) {
                await AuthAPI.setPassword(token, password);
            } else {
                await AuthAPI.resetPassword(token, password);
            }
            setSuccess(true);
        } catch (err) {
            if (err.status === 422 || err.status === 404) {
                setError('Ce lien est invalide ou expiré.');
            } else {
                setError('Service indisponible');
            }
        } finally {
            setSubmitting(false);
        }
    };

    if (!token) {
        return (
            <>
                <section className="vh-100">
                    <div className="container py-5 h-100">
                        <div className="row d-flex justify-content-center align-items-center h-100">
                            <div className="col-12 col-md-8 col-lg-6 col-xl-5">
                                <div className="card shadow-2-strong">
                                    <div className="card-body p-5 text-center">
                                        <p className="text-danger">Lien invalide.</p>
                                        <a href="#!" onClick={e => { e.preventDefault(); navigate('/login'); }}>Retour à la connexion</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </>
        );
    }

    return (
        <>
            <section className="vh-100">
                <div className="container py-5 h-100">
                    <div className="row d-flex justify-content-center align-items-center h-100">
                        <div className="col-12 col-md-8 col-lg-6 col-xl-5">
                            <div className="card shadow-2-strong">
                                <div className="card-body p-5 text-center">
                                    <h3 className="mb-5">{title}</h3>
                                    {success ? (
                                        <>
                                            <p className="text-success">{successMessage}</p>
                                            <a href="#!" onClick={e => { e.preventDefault(); navigate('/login'); }}>Se connecter</a>
                                        </>
                                    ) : (
                                        <form onSubmit={handleSubmit}>
                                            <Field
                                                name="password"
                                                label="Nouveau mot de passe"
                                                value={password}
                                                onChange={e => setPassword(e.currentTarget.value)}
                                                type="password"
                                                error={error}
                                            />
                                            {error && <p className="text-danger text-center">{error}</p>}
                                            <div className="row">
                                                <button type="submit" disabled={submitting} className="col-md btn btn-primary">{submitting ? "Chargement..." : buttonLabel}</button>
                                            </div>
                                        </form>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}
